/* Catharsis product accordions: native <details> enhancement, loaded once. */
(function () {
  'use strict';

  if (window.CatharsisProductAccordions) return;

  var ROOT = '[data-product-accordions]';
  var ROW = '.product-accordion-row';

  function rootFor(node) {
    return node && node.closest ? node.closest(ROOT) : null;
  }

  function closeOtherRows(root, openRow) {
    if (!root || root.getAttribute('data-accordion-mode') !== 'single') return;
    root.querySelectorAll(ROW + '[open]').forEach(function (row) {
      if (row !== openRow) row.open = false;
    });
  }

  function normalise(root) {
    if (!root || root.getAttribute('data-accordion-mode') !== 'single') return;
    var openRows = root.querySelectorAll(ROW + '[open]');
    openRows.forEach(function (row, index) {
      if (index > 0) row.open = false;
    });
  }

  function init(root) {
    if (!root || root.dataset.productAccordionsReady === 'true') return;
    root.dataset.productAccordionsReady = 'true';
    normalise(root);
  }

  function initWithin(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches(ROOT)) init(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(ROOT).forEach(init);
  }

  document.addEventListener('toggle', function (event) {
    var row = event.target;
    if (!row.matches || !row.matches(ROW) || !row.open) return;
    closeOtherRows(rootFor(row), row);
  }, true);

  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target) return;
    if (event.target.matches && event.target.matches(ROOT)) {
      delete event.target.dataset.productAccordionsReady;
    }
    if (!event.target.querySelectorAll) return;
    event.target.querySelectorAll(ROOT).forEach(function (root) {
      delete root.dataset.productAccordionsReady;
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    var row = event.target && event.target.closest ? event.target.closest(ROW) : null;
    if (!row) return;
    var root = rootFor(row);
    if (!root) return;
    row.open = true;
    closeOtherRows(root, row);
  });

  function positionTooltip(button) {
    if (!button) return;
    var feature = button.closest('.product-feature-icon');
    var tip = document.getElementById(button.getAttribute('aria-controls'));
    if (!tip || !feature) return;
    var previousDisplay = tip.style.display;
    tip.style.display = 'block';
    tip.style.left = '50%'; tip.style.transform = 'translateX(-50%)';
    var box = tip.getBoundingClientRect();
    var shift = Math.max(12 - box.left, Math.min(0, document.documentElement.clientWidth - 12 - box.right));
    tip.style.transform = 'translateX(calc(-50% + ' + shift + 'px))';
    tip.style.display = previousDisplay;
  }
  document.addEventListener('focusin', function (event) {
    var button = event.target.closest('.product-feature-icon__info');
    if (button) button.closest('.product-feature-icon').removeAttribute('data-tooltip-dismissed');
    positionTooltip(button);
  });
  document.addEventListener('pointerover', function (event) {
    var feature=event.target.closest('.product-feature-icon');
    if(feature) {
      if (!feature.contains(event.relatedTarget)) feature.removeAttribute('data-tooltip-dismissed');
      positionTooltip(feature.querySelector('.product-feature-icon__info'));
    }
  });
  window.addEventListener('resize', function () {document.querySelectorAll('.product-feature-icon__info').forEach(positionTooltip);}, {passive:true});
  function closeTooltips(except) {
    document.querySelectorAll('.product-feature-icon__info[aria-expanded="true"]').forEach(function (button) {
      if (button !== except) button.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.product-feature-icon__info');
    closeTooltips(button);
    if (button) {button.setAttribute('aria-expanded', String(button.getAttribute('aria-expanded') !== 'true'));positionTooltip(button);}
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeTooltips();
      document.querySelectorAll('.product-feature-icon').forEach(function(feature) {feature.setAttribute('data-tooltip-dismissed', '');});
    }
  });

  window.CatharsisProductAccordions = { init: initWithin };
  initWithin(document);
}());
